import { useEffect, useState } from 'react'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { useClientTabFocus } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/ClientTabStatus/clientTabFocusContext'
import { PanelOverrides, PulsePanelOverrides } from './styled-components'

const usePanelNew = id => {
  const isPulse = usePulseScope()
  const [expanded, setExpanded] = useState(['initial'])
  const { flashedCardId } = useClientTabFocus()
  const isFlashed = isPulse && !!id && flashedCardId === id

  useEffect(() => {
    if (isFlashed) setExpanded(['initial'])
  }, [isFlashed])

  return {
    isPulse,
    expanded,
    onExpandedChange: ({ expanded: newExpanded }) => setExpanded(newExpanded),
    isFlashed,
    panelOverrides: isPulse ? PulsePanelOverrides : PanelOverrides,
  }
}

export default usePanelNew
